import { Text } from '@lightspeed/design-system-react'
import { formatCurrencyValue } from '@vend/utilities'
import React from 'react'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../ng-compat/hooks'

interface Props {
  surcharge: number | string
  surchargeLabel: string
}

export const SurchargeRow: React.FC<Props> = ({
  surcharge,
  surchargeLabel,
}) => {
  const currentOutlet = useRegisterManager().getActiveOutlet()
  const retailer = useRetailerSettingsManager().get()

  return (
    <>
      <Text>{surchargeLabel}</Text>
      <Text type="label" className="sale-total-line-item--value">
        {formatCurrencyValue(
          surcharge,
          retailer.culture,
          currentOutlet.currency,
          currentOutlet.currency_symbol
        )}
      </Text>
    </>
  )
}
